<template>
  <div class="topicContainer">
    <div class="navbarContain">
      <nav-bar />
    </div>

    <div class="mainContain">
      <div class="bgContain">
        <div class="themeTitle">{{ info.title }}</div>
        <div class="themeStatistic">
          {{ statisticsData.discuss_num }}讨论 ·
          {{ statisticsData.read_num }}阅读
        </div>
        <div class="themeIntro">{{ info.introduction }}</div>
      </div>
      <div class="contentList">
        <div
          class="contentItem"
          v-for="(item, index) in contentList"
          :key="index"
        >
          <div class="userContain">
            <img
              :src="item.u_avatar"
              class="userHead"
              @click="toUserHome(item)"
            />
            <div>
              <div class="userTitle" @click="toUserHome(item)">
                {{ item.u_nickname }}
              </div>
              <div class="userinfo">
                <span>{{ item.publish_time }}</span
                ><span v-if="item.u_cert && item.u_cert.info">{{
                  item.u_cert.info
                }}</span>
              </div>
            </div>
          </div>
          <div
            class="content"
            v-html="themeShow(item.n_title)"
            @click="toDetail(item)"
          ></div>
          <div class="thumbContain">
            <el-image
              :src="item1"
              :preview-src-list="item.n_cover_url"
              fit="cover"
              v-for="(item1, index1) in item.n_cover_url"
              :key="index1"
              class="thumb"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="footerContain">
      <div class="innerContain">
        <div class="pubBtn pubScript" @click="toPub(0)">发布文章</div>
        <div class="pubBtn" @click="toPub(1)">视频</div>
        <div class="pubBtn" @click="toPub(2)">帖子</div>
        <div class="pubBtn" @click="toPub(3)">图集</div>
      </div>
    </div>

    <div class="upBtn" @click="toTop()">
      <img src="../../assets/new/up.png" class="upIcon" />
    </div>
  </div>
</template>

<script>
import NavBar from "../../layouts/HeaderAsideLayout/components/NavBar.vue";
import { SWNEWS_HOST } from "../../constants/apiHosts";

export default {
  data() {
    return {
      info: {},
      statisticsData: {},
      contentList: [],
      page: 1,
      size: 20,
      isAll: false,
    };
  },
  components: {
    NavBar,
  },
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll);

    this.getInfo();
    this.getStatistics();
    this.getContentList();
  },
  beforeDestroy() {
    // 离开页面销毁监听
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getInfo() {
      this.$axios
        .get(`${SWNEWS_HOST}/api/hottopic/info?id=${this.$route.query.id}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.info = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getContentList() {
      this.isAll = true;

      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/contentList?id=${this.$route.query.id}&page=${this.page}&size=${this.size}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.contentList = this.contentList.concat(
              res.data.data.returnData
            );
            if (res.data.data.returnData.length >= this.size) {
              this.isAll = false;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getStatistics() {
      this.$axios
        .get(
          `${SWNEWS_HOST}/api/hottopic/statisticsData?id=${this.$route.query.id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.statisticsData = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    themeShow(str) {
      return str.replace(/#([\u4e00-\u9fa5a-zA-Z0-9]+)#/g, (match, text) => {
        return `<span class="topicTag">#${text}#</span>`;
      });
    },
    handleScroll() {
      // 滚动距离
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 可视高度
      const clientHeight = document.documentElement.clientHeight;
      // 总高度
      const scrollHeight = document.documentElement.scrollHeight;

      // 距离底部 小于等于50px 就算触底（可自己改）
      if (scrollTop + clientHeight + 50 >= scrollHeight) {
        if (!this.isAll) {
          this.page += 1;
          this.getContentList();
        }
      }
    },
    toUserHome(item) {
      window.open(`https://www.topnews.cn/home/${item.u_id}`, "_blank");
    },
    toDetail(item) {
      if (item.n_type == 5) {
        window.open(`https://m.topnews.cn/live/${item.n_id}`);
      } else {
        window.open(`https://www.topnews.cn/news/${item.encode_id}`);
      }
    },
    toPub(index) {
      if (index == 0) {
        this.$router.push({
          path: "/scriptWrite",
          query: {
            topicId: this.info.id,
            topicTitle: this.info.title.replace(/#/gi, ""),
          },
        });
      } else if (index == 1) {
        this.$router.push({
          path: "/videoWrite",
          query: {
            topicId: this.info.id,
            topicTitle: this.info.title.replace(/#/gi, ""),
          },
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/post",
          query: {
            topicId: this.info.id,
            topicTitle: this.info.title.replace(/#/gi, ""),
          },
        });
      } else {
        this.$router.push({
          path: "/graphWrite",
          query: {
            topicId: this.info.id,
            topicTitle: this.info.title.replace(/#/gi, ""),
          },
        });
      }
    },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.topicContainer {
  min-height: 100vh;
  background: #edf1f8;
  padding: 80px 0 92px 0;

  .navbarContain {
    width: 100%;
    height: 60px;
    background-color: #fff;
    position: fixed;
    top: 0;
    left: 0;
  }

  .mainContain {
    width: 1140px;
    margin: 0 auto;
    background-color: #ffffff;

    .bgContain {
      width: 100%;
      padding: 45px 60px 60px 60px;
      background: url("../../assets/new/Mask group@2x.png") no-repeat;
      background-size: 100% 100%;

      .themeTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 24px;
        font-weight: 600;
        line-height: 34px;
      }

      .themeStatistic {
        color: #666666;
        font-family: "PingFang SC";
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        letter-spacing: 0.16px;
        margin-top: 8px;
      }

      .themeIntro {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        margin-top: 8px;
      }
    }

    .contentList {
      padding: 0 60px;

      .contentItem {
        padding: 32px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: 0;
        }

        .userContain {
          display: flex;
          align-items: center;

          .userHead {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            object-fit: cover;
            margin-right: 8px;
            cursor: pointer;
          }

          .userTitle {
            color: #333333;
            font-family: "PingFang SC";
            font-size: 14px;
            font-weight: 500;
            line-height: 18px;
            margin-bottom: 4px;
            cursor: pointer;
          }

          .userinfo span {
            color: #999999;
            font-family: "PingFang SC";
            font-size: 12px;
            font-weight: 400;
            line-height: 14px;
            margin-right: 12px;
          }
        }

        .content {
          color: #333333;
          font-family: "PingFang SC";
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          margin-top: 12px;
          cursor: pointer;

          /deep/.topicTag {
            color: #165dff;
          }
        }

        .thumbContain {
          display: flex;

          .thumb {
            width: 160px;
            height: 120px;
            border-radius: 8px;
            margin: 12px 4px 0 0;
            object-fit: cover;
          }
        }
      }
    }
  }

  .footerContain {
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e5e6eb;

    .innerContain {
      height: 72px;
      width: 1140px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 26px;

      .pubBtn {
        width: 80px;
        border-radius: 4px;
        border: 1px solid #ccc;
        color: #333333;
        text-align: center;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 36px;
        cursor: pointer;
        margin-right: 14px;
      }

      .pubScript {
        background: #f32432;
        border: 0;
        color: #fff;
      }
    }
  }

  .upBtn {
    position: fixed;
    right: 30px;
    bottom: 93px;
    z-index: 10;
    width: 48px;
    height: 48px;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.12);

    .upIcon {
      width: 48px;
    }
  }
}
</style>
